import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import FileItemBox from '@shared/molecules/FileItemBox';
import Upload from '@shared/molecules/Upload';

import theme from '@shared/themes/default';

import { useAppGlobals } from '../../../../contexts/AppContext';

const UploadWithListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing.l};
  ${({ height }) =>
    height &&
    `
    height: ${height};
  `}
`;

const WrapList = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  // this corresponds to 4 elements
  max-height: 200px;
  overflow-y: scroll;
  row-gap: ${theme.spacing.s};
  ::-webkit-scrollbar {
    width: 10px;
    height: 30px;
  }
  ::-webkit-scrollbar-thumb:vertical {
    height: 30px;
    background-color: ${theme.palette.disabledLight};
    border-radius: 10px;
  }
`;

const UploadWrapper = styled.div`
  justify-content: center;
  ${({ height }) =>
    height &&
    `
    height: ${height};
  `}
`;

const UploadWithList = ({
  actions,
  deleteFiles,
  description,
  disabled,
  height,
  items,
  maxFiles,
  onStartUpload,
  onUpload,
  uploadHeight,
}) => {
  const { getRestClient } = useAppGlobals();

  return (
    <UploadWithListWrapper height={height}>
      {items.length > 0 && (
        <WrapList>
          {items.map(
            (
              {
                id,
                key,
                name,
                processingStatus,
                icon,
                secondaryIcon,
                actions: itemActions,
              },
              index
            ) => {
              return (
                <FileItemBox
                  actions={itemActions || actions}
                  disabled={disabled}
                  icon={icon}
                  secondaryIcon={secondaryIcon}
                  id={index.toString()}
                  key={id || key}
                  processingStatus={processingStatus || undefined}
                  text={name}
                  theme="dark"
                />
              );
            }
          )}
        </WrapList>
      )}
      <UploadWrapper height={uploadHeight}>
        <Upload
          chunkSize={1024 * 1024 * 10}
          deleteFiles={deleteFiles}
          description={description}
          disabled={disabled || items.length >= maxFiles}
          maxFiles={maxFiles}
          onCompleteUpload={onUpload}
          onStartUpload={onStartUpload}
          restClient={getRestClient()}
        />
      </UploadWrapper>
    </UploadWithListWrapper>
  );
};

UploadWithList.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      ariaLabel: PropTypes.string,
      color: PropTypes.string,
      handler: PropTypes.func,
      icon: PropTypes.object,
      label: PropTypes.string,
    })
  ),
  deleteFiles: PropTypes.bool,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  disabled: PropTypes.bool,
  height: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      actions: PropTypes.array,
      id: PropTypes.string,
      name: PropTypes.string,
      icon: PropTypes.node,
    })
  ),
  maxFiles: PropTypes.number,
  onStartUpload: PropTypes.func,
  onUpload: PropTypes.func,
  uploadHeight: PropTypes.string,
};

export default UploadWithList;
